import {createNotification} from "app/actions/notifications";
import {fixIncorrectStatus} from "custom/demo/requests/admin/super-admin";
import useAppContext from "lib/hooks/use-app-context";

export default function SuperAdmin() {
  const {dispatch} = useAppContext();

  const onClick = (action) => () => {
    action().then(({message, errors}) => {
      if(errors) { return dispatch(createNotification({content: errors.join(", "), type: "error"})); }

      dispatch(createNotification({content: message}));
    });
  };

  return (
    <div className="container">
      <h1>Super Admin</h1>
      <div className="flex gap-2">
        <button className="btn btn-blue" onClick={onClick(fixIncorrectStatus)} type="button">
          Fix Incorrect Status
        </button>
      </div>
    </div>
  );
}
